module.exports = "/_next/static/images/3f88064d6b47c90e0ac5653424a09210-young-people-walking@1x.jpg";